var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedDisLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 9.33333H12.5093C13.5005 9.33333 14.1451 8.29025 13.7019 7.40371L11.3685 2.73705C11.1427 2.28534 10.681 2 10.176 2H7.49747C7.38846 2 7.27985 2.01337 7.17409 2.03981L4.66667 2.66667M9.33333 9.33333V12.6667C9.33333 13.403 8.73638 14 8 14H7.93635C7.60331 14 7.33333 13.73 7.33333 13.397C7.33333 12.9208 7.19238 12.4552 6.92823 12.059L4.66667 8.66667V2.66667M9.33333 9.33333H8M4.66667 2.66667H3.33333C2.59695 2.66667 2 3.26362 2 4V8C2 8.73638 2.59695 9.33333 3.33333 9.33333H5",
    stroke: "#B91C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDisLikeIcon);
export default __webpack_public_path__ + "static/media/redDisLikeIcon.41421093591b2a50026a8d494b5aeecd.svg";
export { ForwardRef as ReactComponent };